module.exports = __webpack_public_path__ + "static/media/NoData.aab5b45e.png";